import React from 'react';
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <footer className="py-3">
          <div className="container-xxl">
            <div className="row align-items-center justify-content-between">
              <div className="col-12">
                <p className='text-center'>{t("footer.title")}</p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  )
}

export default Footer